// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
require('./_set-collection-from')('Set');



//////////////////
// WEBPACK FOOTER
// /Users/cully/projects/Jobs/abound/~/core-js/modules/es7.set.from.js
// module id = ../../node_modules/core-js/modules/es7.set.from.js
// module chunks = 18